/**
 * Terminal state for an embed that cannot show a player. Three variants:
 *
 *   notfound     content is gone or never existed (404, unresolvable, no source)
 *   unavailable  content exists but the viewer cannot see it (401, non-pathkey 403)
 *   error        our side failed (5xx, transport, a malformed page)
 *
 * Bilingual rather than translated: a cross-site iframe gets no I18N_LANGUAGE
 * cookie, and when the UID does not resolve there is no content to read a
 * language off either. The old site redirects embeds it cannot resolve here, so
 * this is the end of the line for dead embeds on both sites.
 */
import { EMBED_FAQ_URLS } from '../../../constants';

const TITLES = {
  notfound: ['Mediasisältöä ei löydy', 'Media is not found'],
  unavailable: ['Mediasisältöä ei voi näyttää', 'This media cannot be shown'],
  error: ['Mediasisällön lataaminen epäonnistui', 'Could not load the media'],
};

const EmbedMessage = ({ variant = 'notfound' }) => {
  const [fi, en] = TITLES[variant] || TITLES.notfound;
  // The FAQ links help where nothing more will happen; on `error` a retry might,
  // so they would only distract.
  const showLinks = variant !== 'error';

  return (
    <div className={`EmbedMessage EmbedMessage--${variant}`}>
      <p className="EmbedMessage-title" lang="fi">
        {fi}
      </p>
      <p className="EmbedMessage-title" lang="en">
        {en}
      </p>
      {showLinks && (
        <p className="EmbedMessage-links">
          {/* target=_top: replace the embedding page, not the frame */}
          <a href={EMBED_FAQ_URLS.fi} target="_top" rel="noopener" lang="fi">
            Lisätietoja
          </a>
          <span aria-hidden="true"> · </span>
          <a href={EMBED_FAQ_URLS.en} target="_top" rel="noopener" lang="en">
            More info
          </a>
        </p>
      )}
    </div>
  );
};

export default EmbedMessage;
